import React, { FC, memo } from "react";
import { Remove as Dash } from "@material-ui/icons";
import { MechanismOfAction } from "../../typescript/interfaces/data";
import Ellipsis from "../Common/Ellipsis";
import Hyperlink from "../Common/Hyperlink";
import config from "../../config";

type MechOfActionTDProps = {
  mechanismsOfAction: MechanismOfAction[];
  width: number;
  noLink: boolean;
};

const MechOfActionTD: FC<MechOfActionTDProps> = memo(({ mechanismsOfAction, width, noLink }) => {
  if (mechanismsOfAction.length === 0) return <Dash fontSize="small" />;

  return (
    <>
      {mechanismsOfAction.map(({ id, name }) => (
        <div key={id}>
          <Hyperlink url={`${config.USER_URL}/Pharma/MechanismOfAction/${id}`} noLink={noLink}>
            <Ellipsis width={width - 25} variant="body2" text={name}>
              {name}
            </Ellipsis>
          </Hyperlink>
        </div>
      ))}
    </>
  );
});

export default MechOfActionTD;
